module.exports = (params) => {
    if ('string' === params) {
        return params
    }

    return Object.keys(params).map((key) => {
        return `${key}=${params[key]}`
    }).join('&')
}